<template>
  <div class="usage">
    <div class="usage__headline">Usage Case Proposal by Vertical</div>
    <div class="usage__tabs">
      <div
        v-for="(item, index) in usage"
        :key="`button-${item.id}`"
        class="usage__tab"
      >
        <Button
          :text="item.category"
          :active="index === currentTab"
          :type="'tab'"
          @click="handleClickTab(index)"
        />
      </div>
    </div>

    <div class="usage__buttons usage__buttons--pc">
      <div
        v-for="(item, index) in usage[currentTab].subCategory"
        :key="`subcategory-${index + 1}`"
        class="usage__button"
      >
        <Button
          :text="item.label"
          :type="'dark'"
          :active="index === currentCategory"
          @click="handleClickButton(index)"
        />
      </div>
    </div>

    <UsageContent
      :content="usage[currentTab].subCategory[currentCategory]"
      @click="handleClickRecommended"
    />

    <div class="usage__buttons usage__buttons--mobile">
      <div
        v-for="(item, index) in usage[currentTab].subCategory"
        :key="`subcategory-${index + 1}`"
        class="usage__button"
      >
        <Button
          :text="item.label"
          :type="'dark'"
          :active="index === currentCategory"
          @click="handleClickButton(index)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Button from './Button.vue'
import UsageContent from './UsageContent.vue'
export default {
  name: 'Usage',
  components: {
    Button,
    UsageContent,
  },
  data() {
    return {
      currentTab: 0,
      currentCategory: 0,
      usage: [
        {
          id: 1,
          category: 'Corporate',
          subCategory: [
            {
              label: 'Lobby',
              imageUrl: `LG-MAGNIT-Usage-Case-01-Corporate-Lobby.jpg`,
              bodycopy: `Elevate your company's first impression with LG MAGNIT, transforming your lobby into its captivating face`,
              recommended: [
                {
                  thumbnail: `LMPA-thumbnail.jpg`,
                  modelname: `LMPA`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
                },
                {
                  thumbnail: `LMPB-thumbnail.jpg`,
                  modelname: `LMPB`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPB007`,
                },
                {
                  thumbnail: `LSAP-thumbnail.jpg`,
                  modelname: `LSAP`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LSAP007`,
                },
                {
                  thumbnail: `LMEA-thumbnail.jpg`,
                  modelname: `LMEA`,
                  description: `LG MAGNIT Essential`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA009`,
                },
              ],
            },
            {
              label: 'Board Room',
              imageUrl: `LG-MAGNIT-Usage-Case-02-Corporate-Board Room.jpg`,
              bodycopy: `LG MAGNIT sets the stage for critical decisions with unmatched clarity and presence`,
              recommended: [
                {
                  thumbnail: `LMPA-thumbnail.jpg`,
                  modelname: `LMPA`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
                },
                {
                  thumbnail: `LMPB-thumbnail.jpg`,
                  modelname: `LMPB`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPB007`,
                },
                {
                  thumbnail: `LAAB-thumbnail.jpg`,
                  modelname: `LAAB`,
                  description: `LG MAGNIT All-in-One`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LAAB136`,
                },
              ],
            },
            {
              label: 'Meeting Room',
              imageUrl: `LG-MAGNIT-Usage-Case-03-Corporate-Meeting Room.jpg`,
              bodycopy: `LG MAGNIT brings clarity and presence to your most critical discussions`,
              recommended: [
                {
                  thumbnail: `LMPA-thumbnail.jpg`,
                  modelname: `LMPA`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
                },
                {
                  thumbnail: `LMPB-thumbnail.jpg`,
                  modelname: `LMPB`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPB007`,
                },
                {
                  thumbnail: `LAAB-thumbnail.jpg`,
                  modelname: `LAAB`,
                  description: `LG MAGNIT All-in-One`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LAAB136`,
                },
                {
                  thumbnail: `LMEA-thumbnail.jpg`,
                  modelname: `LMEA`,
                  description: `LG MAGNIT Essential`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA009`,
                },
              ],
            },
            {
              label: 'Research & Design Lab',
              imageUrl: `LG-MAGNIT-Usage-Case-04-Corporate  Research-Design Lab.jpg`,
              bodycopy: `With LG MAGNIT, capture every level of color from every angle, where every detail fuels discovery`,
              recommended: [
                {
                  thumbnail: `LMPA-thumbnail.jpg`,
                  modelname: `LMPA`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
                },
                {
                  thumbnail: `LMPB-thumbnail.jpg`,
                  modelname: `LMPB`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPB007`,
                },
                {
                  thumbnail: `LSAP-thumbnail.jpg`,
                  modelname: `LSAP`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LSAP007`,
                },
                {
                  thumbnail: `LMEA-thumbnail.jpg`,
                  modelname: `LMEA`,
                  description: `LG MAGNIT Essential`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA009`,
                },
              ],
            },
            {
              label: 'Control Room',
              imageUrl: `LG-MAGNIT-Usage-Case-05-Corporate-Control Room.jpg`,
              bodycopy: `LG MAGNIT ensures accurate color and has Eye Comfort certification for long-term viewing comfort`,
              recommended: [
                {
                  thumbnail: `LMPA-thumbnail.jpg`,
                  modelname: `LMPA`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
                },
                {
                  thumbnail: `LMPB-thumbnail.jpg`,
                  modelname: `LMPB`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPB007`,
                },
                {
                  thumbnail: `LMEA-thumbnail.jpg`,
                  modelname: `LMEA`,
                  description: `LG MAGNIT Essential`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA009`,
                },
              ],
            },
            {
              label: 'Virtual Production',
              imageUrl: `LG-MAGNIT-Usage-Case-06-Corporate-Virtual Production.jpg`,
              bodycopy: `Create limitless possibilities and bring your imagination to reality with LG MAGNIT`,
              recommended: [
                {
                  thumbnail: `LMPA-thumbnail.jpg`,
                  modelname: `LMPA`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
                },
                {
                  thumbnail: `LMPB-thumbnail.jpg`,
                  modelname: `LMPB`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPB007`,
                },
                {
                  thumbnail: `LMEA-thumbnail.jpg`,
                  modelname: `LMEA`,
                  description: `LG MAGNIT Essential`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA009`,
                },
              ],
            },
          ],
        },
        {
          id: 2,
          category: 'Hotel',
          subCategory: [
            {
              label: 'Lobby',
              imageUrl: `LG-MAGNIT-Usage-Case-07-Hotel-Lobby.jpg`,
              bodycopy: `Elevate your hotel's first impression with LG MAGNIT, welcoming guests with stunning visuals`,
              recommended: [
                {
                  thumbnail: `LMPA-thumbnail.jpg`,
                  modelname: `LMPA`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
                },
                {
                  thumbnail: `LMPB-thumbnail.jpg`,
                  modelname: `LMPB`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPB007`,
                },
                {
                  thumbnail: `LSAP-thumbnail.jpg`,
                  modelname: `LSAP`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LSAP007`,
                },
                {
                  thumbnail: `LMEA-thumbnail.jpg`,
                  modelname: `LMEA`,
                  description: `LG MAGNIT Essential`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA009`,
                },
              ],
            },
          ],
        },
        {
          id: 3,
          category: 'Retail',
          subCategory: [
            {
              label: 'Flagship Store',
              imageUrl: `LG-MAGNIT-Usage-Case-08-Retail-Flagship Store.jpg`,
              bodycopy: `LG MAGNIT transforms your flagship store into an unforgettable brand showcase`,
              recommended: [
                {
                  thumbnail: `LMPA-thumbnail.jpg`,
                  modelname: `LMPA`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
                },
                {
                  thumbnail: `LMPB-thumbnail.jpg`,
                  modelname: `LMPB`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPB007`,
                },
                {
                  thumbnail: `LSAP-thumbnail.jpg`,
                  modelname: `LSAP`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LSAP007`,
                },
                {
                  thumbnail: `LMEA-thumbnail.jpg`,
                  modelname: `LMEA`,
                  description: `LG MAGNIT Essential`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA009`,
                },
              ],
            },
            {
              label: 'Automotive Retail',
              imageUrl: `LG-MAGNIT-Usage-Case-09-Retail-Automotive Retail.jpg`,
              bodycopy: `Show your car design as it is with LG MAGNIT; every line, curve, and color comes to life`,
              recommended: [
                {
                  thumbnail: `LMPA-thumbnail.jpg`,
                  modelname: `LMPA`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
                },
                {
                  thumbnail: `LMPB-thumbnail.jpg`,
                  modelname: `LMPB`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPB007`,
                },
                {
                  thumbnail: `LSAP-thumbnail.jpg`,
                  modelname: `LSAP`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LSAP007`,
                },
                {
                  thumbnail: `LMEA-thumbnail.jpg`,
                  modelname: `LMEA`,
                  description: `LG MAGNIT Essential`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA009`,
                },
              ],
            },
            {
              label: 'Sports Bar',
              imageUrl: `LG-MAGNIT-Usage-Case-10-Retail-Sports Bar.jpg`,
              bodycopy: `LG MAGNIT turns every game into a spectacle, offering every viewer an immersive front-row experience`,
              recommended: [
                {
                  thumbnail: `LMPA-thumbnail.jpg`,
                  modelname: `LMPA`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
                },
                {
                  thumbnail: `LMPB-thumbnail.jpg`,
                  modelname: `LMPB`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPB007`,
                },
                {
                  thumbnail: `LMEA-thumbnail.jpg`,
                  modelname: `LMEA`,
                  description: `LG MAGNIT Essential`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA009`,
                },
              ],
            },
          ],
        },
        {
          id: 4,
          category: 'Residential',
          subCategory: [
            {
              label: 'Residential',
              imageUrl: `LG-MAGNIT-Usage-Case-11-Residential.jpg`,
              bodycopy: `See your favorite movies, shows, and sports like never before with stunningly vivid visuals`,
              recommended: [
                {
                  thumbnail: `LMPA-thumbnail.jpg`,
                  modelname: `LMPA`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
                },
                {
                  thumbnail: `LMPB-thumbnail.jpg`,
                  modelname: `LMPB`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPB007`,
                },
                {
                  thumbnail: `LSAH-thumbnail.jpg`,
                  modelname: `LSAH`,
                  description: `LG MAGNIT Active Micro LED`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-active-micro-led/LSAH007`,
                },
              ],
            },
          ],
        },
        {
          id: 5,
          category: 'Public',
          subCategory: [
            {
              label: 'Stadium VIP Lounge',
              imageUrl: `LG-MAGNIT-Usage-Case-13-Public-Stadium-VIP-Lounge.jpg`,
              bodycopy: `Elevate the prestige of your VIP experience with LG MAGNIT, which delivers unmatched visual luxury`,
              recommended: [
                {
                  thumbnail: `LMPA-thumbnail.jpg`,
                  modelname: `LMPA`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPA007`,
                },
                {
                  thumbnail: `LMPB-thumbnail.jpg`,
                  modelname: `LMPB`,
                  description: `LG MAGNIT`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-micro-led/LMPB007`,
                },
                {
                  thumbnail: `LMEA-thumbnail.jpg`,
                  modelname: `LMEA`,
                  description: `LG MAGNIT Essential`,
                  link: `/products-solutions/led-signage/indoor-led/lg-magnit-essential/LMEA009`,
                },
              ],
            },
          ],
        },
      ],
    }
  },
  methods: {
    handleClickTab(i) {
      this.currentTab = i
      this.currentCategory = 0
    },
    handleClickButton(i) {
      this.currentCategory = i
    },
    handleClickRecommended(recommendedItem) {
      this.$emit('click', recommendedItem)
      console.log(recommendedItem)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
.usage {
  position: relative;
  display: flex;
  flex-direction: column;
  &__headline {
    font-size: 52px;
    font-weight: 600;
    text-align: center;
  }
  &__tabs {
    display: flex;
    gap: 84px;
    justify-content: center;
    margin-top: 76px;
  }
  &__buttons {
    display: flex;
    gap: 39px;
    justify-content: center;
    margin-top: 76px;
    &--pc {
      @media screen and (max-width: 1080px) {
        display: none;
      }
    }
    &--mobile {
      display: none;
      @media screen and (max-width: 1080px) {
        display: flex;
      }
    }
  }
  @media screen and (max-width: 1080px) {
    padding: 0 calcQuarter(60);
    &__headline {
      font-size: calcQuarter(108);
      line-height: calcQuarter(118);
    }
    &__tabs {
      gap: 0;
      justify-content: space-between;
      margin-top: calcQuarter(110);
    }
    &__buttons {
      gap: calcQuarter(30);
      flex-wrap: wrap;
      justify-content: center;
      margin-top: calcQuarter(90);
    }
  }
}
</style>
